export default "__VITE_ASSET__CyJ_jcKr__"